import React, { useState } from 'react'
import { supabase } from '../supabaseClient'
import TopNav from '../components/TopNav'

export default function ChangePassword() {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState(null)

  async function handleUpdate() {
    if (!password || !confirm) { setError('Please fill in both fields.'); return }
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return }
    if (password !== confirm) { setError('Passwords do not match.'); return }
    setLoading(true)
    setError(null)
    const { error: updateError } = await supabase.auth.updateUser({ password })
    if (updateError) { setError(updateError.message); setLoading(false); return }
    setDone(true)
    setLoading(false)
  }

  return (
    <div>
      <TopNav active="account" />
      <div className="container-narrow">
        <div style={{ textAlign: 'center', paddingTop: '48px', marginBottom: '32px' }}>
          <h1 style={{ fontFamily: 'var(--ff-d)', fontWeight: '700', fontSize: '36px', marginBottom: '8px' }}>Change password</h1>
          <p style={{ color: 'var(--text-2)' }}>Update your Predicta account password</p>
        </div>
        <div className="card">
          {done ? (
            <div style={{ textAlign: 'center', padding: '16px 0' }}>
              <div style={{ fontSize: '40px', marginBottom: '16px' }}>✅</div>
              <h3 style={{ fontFamily: 'var(--ff-d)', fontSize: '22px', marginBottom: '8px' }}>Password updated</h3>
              <p style={{ color: 'var(--text-2)', fontSize: '13px', marginBottom: '24px' }}>Your password has been changed successfully.</p>
              <a href="/" className="btn btn-primary">Back to home</a>
            </div>
          ) : (
            <>
              {error && (
                <div style={{ background: 'rgba(220,38,38,0.08)', border: '1px solid rgba(220,38,38,0.2)', borderRadius: 'var(--r)', padding: '10px 14px', marginBottom: '16px' }}>
                  <p style={{ color: 'var(--red)', fontSize: '13px' }}>{error}</p>
                </div>
              )}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '20px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--text-2)', marginBottom: '7px' }}>New password</label>
                  <input type="password" placeholder="Min 6 characters" value={password} onChange={e => setPassword(e.target.value)} />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', letterSpacing: '.08em', textTransform: 'uppercase', color: 'var(--text-2)', marginBottom: '7px' }}>Confirm new password</label>
                  <input type="password" placeholder="Repeat your new password" value={confirm} onChange={e => setConfirm(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleUpdate()} />
                </div>
              </div>
              <button className="btn btn-primary" onClick={handleUpdate} disabled={loading} style={{ width: '100%', padding: '12px' }}>
                {loading ? 'Updating...' : 'Update password'}
              </button>
              <p style={{ textAlign: 'center', marginTop: '14px', fontSize: '13px' }}>
                <a href="/" style={{ color: 'var(--text-3)' }}>Cancel</a>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}